import { LOCAL_INSTANCE, ServiceSalesInbox } from '../../services/service-sales-inbox';
import appState from '../../state/AppStateContainer';
import { InboxAdapter, SalesInboxItem, toInboxQuery } from './types';

export const salesInboxAdapter: InboxAdapter<SalesInboxItem> = {
  messageTypes: ['standardMessage', 'quotationMessage'],
  createActivity: () => false,

  // A project id is only unique within the instance that holds it.
  groupKey: item => `${item.instance ?? ''}:${item.projectId}`,
  counterpart: item => item.buyerOrgName,

  fetchPage: opts => ServiceSalesInbox.getInbox(toInboxQuery(opts)),
  fetchGroupPage: (lastItem, opts) =>
    ServiceSalesInbox.getInbox({ ...toInboxQuery(opts), projectIds: [lastItem.projectId], instance: lastItem.instance ?? LOCAL_INSTANCE }),

  markRead: item => ServiceSalesInbox.markRead(item.conversationId, item.instance),
  markUnread: item => ServiceSalesInbox.markUnread(item.conversationId, item.instance),
  refreshBadge: () => appState.refreshSalesInboxNotifications(),
  markAllRead: () => ServiceSalesInbox.markAllRead(),

  loadThread: async item => (await ServiceSalesInbox.getConversation(item.conversationId, item.instance)).conversation,
  sendReply: (item, text, files) => ServiceSalesInbox.postReply(item.conversationId, text, files, item.instance),
  isOwnMessage: msg => !!msg.supplierMemberId,
  conversationLink: item => item.bidPageLink,
  isProjectClosed: item => item.projectIsOpen === false,
  downloadAttachment: (item, attachment) =>
    ServiceSalesInbox.downloadAttachment(item.conversationId, attachment.file, attachment.fileName, item.instance),
};
